import IpsTextarea from './IpsTextarea.vue';

export default IpsTextarea;
